import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const fetchMode = () => {
  cache = api.get("/public/booking-mode").then((r) => r.data).catch(() => ({ phone_verification: true, phone: "+393514269681" }));
  return cache;
};

// "Modalità prenotazioni su verifica telefonica" (admin toggle); fetched once per page load
export function useBookingMode() {
  const [mode, setMode] = useState(null);
  useEffect(() => {
    let alive = true;
    (cache || fetchMode()).then((m) => alive && setMode(m));
    return () => { alive = false; };
  }, []);
  return mode;
}

export const refreshBookingMode = fetchMode;
